<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vgGUNx/tc-custom/9781459290150.jpg?1731055884186" alt="This image is the cover for the book Fighting Chance"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fighting Chance
      </h1>
      <p class="bookDescription body article font2">
        <b>She’s on the ropes over the MMA fighter she once lost, in this knockout second-chance romance from the <i>New York Times</i>–bestselling author.</b><br/><br/>All work and no play makes Adeline Kendrick a dull girl, so when she heads to a casino resort for a friend’s bachelorette weekend, she’s ready to have a good time. Until she runs into Brendan Quinn, professional fighter and the one who got away—the one her family drove away—and things take a turn for the interesting.<br/><br/>Running into his ex won’t shake Brendan. Even if it brings up the old pain of loving her when she was only slumming. Even if she looks really good. In fact, what better way to get over the past than to take advantage of the still-sizzling chemistry running hot between them? He’s there to win an MMA fight, but he won’t say no to a little physical relief of a different kind.<br/><br/>But when the weekend is over, Adeline isn’t ready to give up her second chance that easily. Brendan is still the one for her, no matter what her family thinks. Now, if only she can convince him of that . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shannon Stacey
      </h2>
      
      <p class="authorDescription body article"><I>New York Times&#160;</I>and <I>USA Today</I> bestselling author Shannon Stacey lives with her husband and two sons in New England, where her two favorite activities are writing stories of happily ever after and off-roading with her friends and family. You can contact Shannon through her website, www.shannonstacey.com, as well as sign up for her newsletter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ae44ad4a